import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';


import { FeatherIconsComponent } from './components/feather-icons/feather-icons.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';

import { ToggleFullscreenDirective } from "./directives/fullscreen.directive";
import { ContentLayoutComponent } from './layout/content-layout/content-layout.component';
import { NavService } from './service/nav.service';
import { WINDOW_PROVIDERS } from './service/windows.service';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { RightSidebarComponent } from './components/right-sidebar/right-sidebar.component';
import { CategoryService } from './service/category.service';
import {colorService} from './service/color.service';
import {sizeService} from './service/size.service';
import { OrderService } from './service/order.service';
import { variantService } from 'src/app/shared/service/variant.service';

import { subcategoryService } from './service/subcategory.service';
import { collectionService } from './service/collection.service';
import { NotificationService } from './service/notification.service';
import { HttpClientModule } from '@angular/common/http';
import { brandService } from './service/brand.service';
import { tagService } from './service/tag.service';
import { CategoryDTO } from './models/model';
import { LocalDataSource } from 'ng2-smart-table';
import { productService } from './service/product.service';
@NgModule({
  declarations: [
    ToggleFullscreenDirective,
    FeatherIconsComponent,
    FooterComponent,
    HeaderComponent,
    SidebarComponent,
    ContentLayoutComponent,
    BreadcrumbComponent,
    RightSidebarComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    HttpClientModule,
  ],
  providers: [productService,colorService,sizeService,variantService,NavService, CategoryService, subcategoryService, brandService, collectionService, NotificationService, tagService, OrderService,WINDOW_PROVIDERS],
  exports: [FeatherIconsComponent, ToggleFullscreenDirective]
})
export class SharedModule {
  public static apiURL: string = "https://itsolutionstuff.com/";

  public static brandList: any;

  public static categoryList: any;
  public static collectionList:any;
  public static subcategoryList: any;

  constructor() {





  }
}
